import { ChromeAppResponse } from 'Environment/ChromeApp/types';
import { ChromeAndHtml5 } from 'GlobalAppConfigService/ChromeAppHtml5/common';
import { PromiseMap } from 'GlobalAppConfigService/ChromeAppHtml5/promiseMap';

export type EventHandlerCallback = (response: any) => Promise<void>;

/*
  This Singleton class helps us avoid registering multiple event 
  listeners for the same events not matter how many time we crate the GacsHTML5transport.

  The GacsChromeAppTransport is singleton already so it doesnt benefit much from this.
  But the GacsHTML5transport can be created multiple times in the same page due to the nature
  of how HTML5 TAB applications work.
*/
export class GacsHTMLChromeEventManager {
	private static instance: GacsHTMLChromeEventManager;
	private promiseMap = new PromiseMap();

	private constructor() {
		// Register the event listener for messages from the
		window.addEventListener('message', this.eventHandler, false);
	}

	private eventHandler = async (response?: ChromeAndHtml5.WindowEventMessageType) => {
		if (!this.shouldProcessResponse(response)) {
			return;
		}

		if (!this.isSuccessResponse(response.data)) {
			this.promiseMap.reject(response.data.correlationId, response.data);
			return;
		}

		this.promiseMap.resolve(response.data.correlationId, response.data);
	};

	private shouldProcessResponse(
		response?: ChromeAndHtml5.WindowEventMessageType
	): boolean {
		if (!response?.data?.correlationId) {
			return false;
		}
		return !!this.promiseMap.has(response.data.correlationId);
	}

	private isSuccessResponse(response?: ChromeAppResponse): boolean {
		return response?.status === ChromeAndHtml5.SUCCESS;
	}

	public set(correlationId: string, resolve: Function, reject: Function) {
		this.promiseMap.set(correlationId, resolve, reject);
	}

	public resolve(correlationId: string, result: any) {
		this.promiseMap.resolve(correlationId, result);
	}

	public reject(correlationId: string, error: any) {
		this.promiseMap.reject(correlationId, error);
	}

	/**
	 * Gets the singleton instance of CommonEventHandler
	 */
	public static getInstance(): GacsHTMLChromeEventManager {
		if (!GacsHTMLChromeEventManager.instance) {
			GacsHTMLChromeEventManager.instance = new GacsHTMLChromeEventManager();
		}
		return GacsHTMLChromeEventManager.instance;
	}
}
